import React from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import { useWizard } from '../../context/WizardContext';
import { useProgressTracking } from '../../hooks/useProgressTracking';
import CurrencyInput from '../common/CurrencyInput';

const BasicFinancialsStep: React.FC = () => {
  const { wizardData, updateWizardData } = useWizard();
  useProgressTracking({ stepName: 'Income & Savings', stepNumber: 2 });
  const { personal, employment } = wizardData;

  const handleIncomeChange = (value: number) => {
    updateWizardData({
      employment: {
        ...employment,
        client1: { ...employment.client1, currentIncome: value }
      }
    });
  };

  const handlePartnerIncomeChange = (value: number) => {
    updateWizardData({
      employment: {
        ...employment,
        client2: { ...employment.client2, currentIncome: value }
      }
    });
  };

  const handleTotalAssetsChange = (value: number) => {
    updateWizardData({ totalAssets: value });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" fontWeight="bold" textAlign="center">
        Income & Savings
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Help us understand your financial picture
      </Typography>

      <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <CurrencyInput
            label={personal.hasPartner ? `${personal.client1.firstName || 'Your'}'s Annual Income` : 'How much do you make annually?'}
            value={employment.client1.currentIncome || ''}
            onChange={handleIncomeChange}
            helperText="Annual pre-tax income (leave blank if retired)"
            fullWidth
          />

          {personal.hasPartner && (
            <CurrencyInput
              label={`${personal.client2.firstName || "Partner"}'s Annual Income`}
              value={employment.client2.currentIncome || ''}
              onChange={handlePartnerIncomeChange}
              helperText="Leave blank if not working"
              fullWidth
            />
          )}

          <CurrencyInput
            label="How much do you have in savings and investments?"
            value={wizardData.totalAssets || ''}
            onChange={handleTotalAssetsChange}
            helperText="Total savings and investment accounts"
            fullWidth
            required
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default BasicFinancialsStep;
